exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-bell[data-v-5ef269fc] {\n  position: relative;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.notification-badge[data-v-5ef269fc] {\n  position: absolute;\n  top: -4px;\n  right: -6px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: #ea5455;\n  color: #fff;\n  font-size: 0.65rem;\n  line-height: 16px;\n  text-align: center;\n  font-weight: 600;\n}\r\n", ""]);

// exports
